<div class="flex h-full min-h-0 w-full flex-col">
  <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-3 py-3">
    @if (error()) {
      <p class="m-0 text-xs text-red-600" role="alert">{{ error() }}</p>
    }

    @for (turn of turns(); track $index) {
      @if (turn.role === "user") {
        <section class="flex flex-col gap-1.5">
          <span
            class="text-[10px] font-semibold uppercase tracking-wide text-primary"
            >You</span
          >
          <div
            class="rounded-lg border border-primary/25 bg-primary/10 px-3 py-2 shadow-sm"
          >
            <p
              class="m-0 text-sm font-semibold leading-snug text-surface-switch-900 whitespace-pre-wrap"
            >
              {{ turn.text }}
            </p>
          </div>
        </section>
      } @else {
        <section class="flex flex-col gap-1.5 pl-1">
          <span class="text-[10px] font-medium text-surface-switch-500"
            >Tangi-Bot</span
          >
          <div
            class="rounded-md border-l-2 border-surface-switch-200 bg-surface-switch-0 py-1.5 pl-3 pr-1.5"
          >
            <p
              class="m-0 text-xs leading-relaxed text-surface-switch-700 whitespace-pre-wrap"
            >
              {{ turn.text }}
            </p>
          </div>
        </section>
      }
    }

    @if (waitingForFirstChunk()) {
      <p class="m-0 text-xs text-surface-switch-500 animate-pulse">Thinking…</p>
    }
  </div>

  <form
    class="shrink-0 border-t border-surface-switch-200 px-3 py-3"
    (ngSubmit)="$event.preventDefault(); send()"
  >
    <div class="relative">
      <label class="sr-only" for="agent-drawer-message">Message</label>
      <textarea
        id="agent-drawer-message"
        name="agentMessage"
        [(ngModel)]="messageText"
        rows="3"
        [disabled]="loading()"
        (keydown.enter)="onEnterKey($event)"
        placeholder="Ask Tangi-Bot to curate reports, build quotes, manage materials or anything Tangible!"
        class="m-0 block w-full resize-none rounded-md border border-surface-switch-300 bg-surface-switch-0 px-2.5 py-1.5 pb-9 text-xs leading-relaxed text-surface-switch-900 placeholder:text-surface-switch-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:opacity-60"
      ></textarea>
      <p-button
        type="button"
        icon="pi pi-arrow-circle-up"
        size="small"
        [text]="true"
        severity="secondary"
        styleClass="!absolute bottom-1.5 right-1.5 z-10 !min-h-0 !min-w-0 !p-0"
        [attr.aria-label]="'Send message'"
        [disabled]="loading()"
        (onClick)="send()"
      />
    </div>
  </form>
</div>
